import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {login} from '../../actions/Index';
import {renderPasswordInputField, renderEmailInputField} from '../Layout/FormInputs'
import {toastr} from 'react-redux-toastr';
import {updateUserDetailsLocalStorage, getVideoDetailLocalStorage, saveInProps} from "../../actions/Common";
import { saveVideoClickData } from "../../actions/DashboardAction";
import {Loader} from "../Common/Loader";
import {langs} from "../../config/localization";
import {getTagCloudDetails} from "../../actions/DashboardAction";
import {focusOnError} from "../../utils";

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showLoader : false
        };
    }

    /**
     * Submit the login form
     * @param values
     */
    onSubmit(values){
        this.setState({showLoader : true});
        //Call the login action
        this.props.login(values, (response)=>{
            this.setState({showLoader : false});            
            if(response.status === 200){
                //On successful login store response data in local storage
                this.setState({showLoader : true});
                updateUserDetailsLocalStorage(response.data);
                let video_detail = getVideoDetailLocalStorage();
                this.props.saveVideoClickData(video_detail, (response)=>{
                    
                    //Call API for getting tag cloud detail
                    this.props.getTagCloudDetails("", "", "", (response)=>{
                        this.setState({ showLoader: false });
                       
                        // Redirection condition 
                        if(response.data.length>0){
                            this.props.history.push('/dashboard');
                        }else{
                            window.location.assign('/registration-success');
                        }

                        //hide loader on the last API response 
                        this.setState({ showLoader: false });
                    });                                     
                });               
                //window.location.assign('/dashboard');
            }else {
                if(response.status === 403) {
                    toastr.error(langs.error, langs.messages.invalid_credentials);
                } else {
                    toastr.error(langs.error, langs.messages.default_error);
                }
            }
        });
    }

    /**
     * Render the login form
     * @returns {*}
     */
    render(){
        const {handleSubmit} = this.props;
        if(!this.state.showLoader) {
            return (
                <section className="section-login">
                    <div className="row">
                        <div className="medium-12 columns">
                            <div className="login-wrapper">
                                <div className="login-container">
                                    <div className="login-left primary-gradient-bg">
                                            <div className="globe-bg">
                                                <h2>Welcome to earthDECKS, <span>Login</span> to continue</h2>
                                            </div>
                                            <div className="map-bg">
                                                <img src="assets/images/eathdeck/map.png" />
                                            </div>
                                    </div>
                                    <div className="login-right">
                                        <h1>Login</h1>
                                        <form noValidate className="form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                          <div className="login-form">
                                              <div className="form-group email">
                                                  <label>{langs.email_address}*</label>
                                                  <Field
                                                      name="email"
                                                      component={renderEmailInputField}
                                                      className=""
                                                  />
                                              </div>
                                              <div classname="clearfix"></div>
                                              <div className="form-group password">
                                                  <label>Password*</label>
                                                  <Field
                                                      name="password"
                                                      component={renderPasswordInputField}
                                                      className=""
                                                  />
                                              </div>
                                              <div className="form-group text-center">
                                                  <button type="submit" className="btn-primary primary-gradient-bg">
                                                      <span>LOGIN</span>
                                                  </button>
                                              </div>
                                              <div className="form-group text-center">
                                                  <label><a href="/forgot-password" className="">Forgot Password?</a></label>
                                              </div>
                                              <div className="form-group no-account text-center">
                                                  <p>Don't have an account? <a href="/signup" className="">Sign Up</a></p>
                                              </div>
                                          </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        } else {
            return <Loader />
        }
    }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};

    if(!values.email){
        errors.email = langs.validation_messages.email_required;
    }

    if(values.email && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values.email) == false){
        errors.email = langs.validation_messages.email_pattern;
    }

    if(!values.password){
        errors.password = langs.validation_messages.password_required;
    }

    if(values.password && values.password.length > 32){
        errors.password = langs.validation_messages.password_length;
    }

    return errors;
}

export default reduxForm({
    validate,
    form: 'Login',
    onSubmitFail: (errors) => {
        focusOnError(errors)
    }
})(
    connect(null, {login, saveVideoClickData, getTagCloudDetails, saveInProps})(Login)
);



// WEBPACK FOOTER //
// ./components/Auth/Login.js